import { useMemo } from 'react'
import { IntlShape } from 'react-intl'

import { ProgramCoverageBreakdown } from '../../../models/user/User'
import { programSupportForAttribute } from '../utils'

export const useGetBHBSessionCount = (
  intl: IntlShape,
  clientDetails?: { open_bhb_session_count?: number } | null,
  selectedEpisode?: {
    program_name?: any
  },
  programCoverageBreakdown?: ProgramCoverageBreakdown,
) => {
  return useMemo(() => {
    const isCurrentProgramCoveredByBHB = programSupportForAttribute(
      'bhbSupported',
      selectedEpisode,
      programCoverageBreakdown,
    )

    if (!isCurrentProgramCoveredByBHB) {
      return null
    }

    return {
      label: intl.formatMessage({
        defaultMessage: 'HPI sessions used',
        description: 'Number of HPI sessions completed',
      }),
      value: clientDetails?.open_bhb_session_count?.toString() ?? '0',
    }
  }, [selectedEpisode, programCoverageBreakdown, intl, clientDetails?.open_bhb_session_count])
}
